import { useTranslation } from "react-i18next";
import { Caption, P } from "@/components/Typography";
import Accordion from "@/components/Accordion";

const IntegrationFAQs = () => {
  const { t } = useTranslation();

  const renderContactsForwardingContent = () => (
    <Caption className="text-black">
      {t(
        "emailOnboarding.klaviyoOptIn.left.accordions.contactsForwarding.content.paragraph1",
      )}
      <ol className="flex list-[lower-roman] flex-col gap-10 ps-20 text-start text-primary-dark">
        <li>
          <Caption className="text-black">
            {t(
              "emailOnboarding.klaviyoOptIn.left.accordions.contactsForwarding.content.list1",
            )}
          </Caption>
        </li>
        <li>
          <Caption className="text-black">
            {t(
              "emailOnboarding.klaviyoOptIn.left.accordions.contactsForwarding.content.list2",
            )}
          </Caption>
        </li>
        <li>
          <Caption className="text-black">
            {t(
              "emailOnboarding.klaviyoOptIn.left.accordions.contactsForwarding.content.list3",
            )}
          </Caption>
        </li>
        <li>
          <Caption className="text-black">
            {t(
              "emailOnboarding.klaviyoOptIn.left.accordions.contactsForwarding.content.list4",
            )}
          </Caption>
        </li>
        <li>
          <Caption className="text-black">
            {t(
              "emailOnboarding.klaviyoOptIn.left.accordions.contactsForwarding.content.list5",
            )}
          </Caption>
        </li>
      </ol>
      {t(
        "emailOnboarding.klaviyoOptIn.left.accordions.contactsForwarding.content.paragraph2",
      )}
    </Caption>
  );

  return (
    <div className="mt-30 flex flex-col gap-20 md:mt-50">
      <Accordion
        defaultIsExpanded
        trackingId={{
          eventName: "components.accordion.expand-faq",
          additionalProperties: {
            question_name: t(
              "emailOnboarding.klaviyoOptIn.left.accordions.newDatashipsLists.title",
            ),
          },
        }}
        topContent={
          <P className="font-bold">
            {t(
              "emailOnboarding.klaviyoOptIn.left.accordions.newDatashipsLists.title",
            )}
          </P>
        }>
        <Caption className="text-black">
          {t(
            "emailOnboarding.klaviyoOptIn.left.accordions.newDatashipsLists.content",
          )}
        </Caption>
      </Accordion>
      <Accordion
        trackingId={{
          eventName: "components.accordion.expand-faq",
          additionalProperties: {
            question_name: t(
              "emailOnboarding.klaviyoOptIn.left.accordions.twoTypes.title",
            ),
          },
        }}
        topContent={
          <P className="font-bold">
            {t("emailOnboarding.klaviyoOptIn.left.accordions.twoTypes.title")}
          </P>
        }>
        <Caption className="text-black">
          {t("emailOnboarding.klaviyoOptIn.left.accordions.twoTypes.content")}
        </Caption>
      </Accordion>
      <Accordion
        trackingId={{
          eventName: "components.accordion.expand-faq",
          additionalProperties: {
            question_name: t(
              "emailOnboarding.klaviyoOptIn.left.accordions.bothDouble.title",
            ),
          },
        }}
        topContent={
          <P className="font-bold">
            {t("emailOnboarding.klaviyoOptIn.left.accordions.bothDouble.title")}
          </P>
        }>
        <Caption className="text-black">
          {t("emailOnboarding.klaviyoOptIn.left.accordions.bothDouble.content")}
        </Caption>
      </Accordion>
      <Accordion
        trackingId={{
          eventName: "components.accordion.expand-faq",
          additionalProperties: {
            question_name: t(
              "emailOnboarding.klaviyoOptIn.left.accordions.contactsForwarding.title",
            ),
          },
        }}
        topContent={
          <P className="font-bold">
            {t(
              "emailOnboarding.klaviyoOptIn.left.accordions.contactsForwarding.title",
            )}
          </P>
        }>
        {renderContactsForwardingContent()}
      </Accordion>
      <Accordion
        trackingId={{
          eventName: "components.accordion.expand-faq",
          additionalProperties: {
            question_name: t(
              "emailOnboarding.klaviyoOptIn.left.accordions.determineMarketable.title",
            ),
          },
        }}
        topContent={
          <P className="font-bold">
            {t(
              "emailOnboarding.klaviyoOptIn.left.accordions.determineMarketable.title",
            )}
          </P>
        }>
        <Caption className="text-black">
          {t(
            "emailOnboarding.klaviyoOptIn.left.accordions.determineMarketable.content",
          )}
        </Caption>
      </Accordion>
    </div>
  );
};

export default IntegrationFAQs;
